const BUSINESS_SUFFIXES = [
  "llc",
  "l.l.c.",
  "inc",
  "inc.",
  "corp",
  "corp.",
  "corporation",
  "co",
  "co.",
  "company",
  "ltd",
  "ltd.",
  "limited",
  "llp",
  "l.l.p.",
  "lp",
  "l.p.",
  "pa",
  "p.a.",
  "pc",
  "p.c.",
  "pllc",
  "p.l.l.c.",
  "plc",
  "p.l.c.",
  "group",
  "holdings",
  "enterprises",
  "solutions",
  "services",
  "partners",
  "partnership",
  "associates",
  "association",
  "consulting",
  "consultants",
  "agency",
  "technologies",
  "technology",
  "tech",
  "dba",
  "d/b/a",
  "management",
  "properties"
];

export function normalizeBusinessName(name: string): string {
  // Convert to lowercase and trim
  let normalized = name.toLowerCase().trim();

  // Remove common suffixes
  BUSINESS_SUFFIXES.forEach(suffix => {
    const regex = new RegExp(`\\s+${suffix}\\s*$`, "i");
    normalized = normalized.replace(regex, "");
  });

  // Remove punctuation and extra whitespace
  normalized = normalized
    .replace(/[.,;:!?'"]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  return normalized;
}

export function checkBusinessNameMatch(
  businessNameA: string,
  businessNameB: string
) {
  const normalizedA = normalizeBusinessName(businessNameA);
  const normalizedB = normalizeBusinessName(businessNameB);

  if (!normalizedA || !normalizedB) {
    return false;
  }

  // Check if either normalized name contains the other as a substring
  return normalizedA.includes(normalizedB) || normalizedB.includes(normalizedA);
}

export function checkBusinessNamesMatch(
  namesA: string[],
  namesB: string[]
): [string, string] | false {
  for (const nameA of namesA) {
    for (const nameB of namesB) {
      if (checkBusinessNameMatch(nameA, nameB)) {
        return [nameA, nameB];
      }
    }
  }
  return false;
}
